
export const BASE_URL = "https://wapi.rizee.in/api/v1";

// 🚀 WhatsApp Embedded Signup (Facebook On-Boarding) — external service, no bearer auth
export const EMBED_SIGNUP_BASE = "https://wapi.rizee.in/api/v1/embed_signup";

export const EMBED_SIGNUP_ROUTES = {
    CHECK: `${EMBED_SIGNUP_BASE}/check`,
    CREATE: `${EMBED_SIGNUP_BASE}/create`,
    PAYMENT_UPDATE: `${EMBED_SIGNUP_BASE}/paymentUpdate`,
    REGISTER: `${EMBED_SIGNUP_BASE}/register`,
};

// 🚀 Facebook Embedded Signup SDK config
export const FB_EMBED_SIGNUP_CONFIG = {
    APP_ID: "1701243081021572",
    CONFIG_ID: "1324494115681412",
    GRAPH_VERSION: "v19.0",
};

export const API_ROUTES = {
    // 🚀 LOGIN APIS
    LOGIN: `${BASE_URL}/auth/login`,
    AUTO_LOGIN: `${BASE_URL}/auth/auto-login`,

    // 🚀 BRANCH DEPARTMENT APIS
    BRANCHS: `${BASE_URL}/general/branches`,
    DEPARTMENTS: `${BASE_URL}/general/departments`,
    BRANCH_DEPARTMENTS: `${BASE_URL}/general/branch-department`,
    ADD_BRANCH: `${BASE_URL}/general/add-branch`,
    ADD_DEPARTMENT: `${BASE_URL}/general/add-department`,
    ADD_BRANCH_DEPARTMENT: `${BASE_URL}/general/add-branch-department`,

    // 🚀 GENERAL APIS
    FILE_UPLOAD: `${BASE_URL}/general/file-upload`,

    // 🚀 QRCODE APIS
    QR_CODES: `${BASE_URL}/qrcode`,
    ADD_QRCODE: `${BASE_URL}/qrcode/add-qrcode`,
    GET_INDIVIDUALDATA: `${BASE_URL}/qrcode/individual-history`,

    // 🚀 EMPLOYEES APIS
    EMPLOYEES: `${BASE_URL}/employee`,
    EMP_LEVELS: `${BASE_URL}/general/employee-levels`,
    EMP_MODULES: `${BASE_URL}/general/employee-modules`,
    ADD_EMPLOYEE: `${BASE_URL}/employee/add`,
    UPDATE_EMPLOYEE: `${BASE_URL}/employee/update`,

    // 🚀 CONTACT APIS
    CONTACTS: `${BASE_URL}/users`,
    ADDCONTACT: `${BASE_URL}/users/add`,
    UPDATECONTACT: `${BASE_URL}/users/update`,
    TAGS: `${BASE_URL}/general/tags`,
    ADDTAG: `${BASE_URL}/general/add-tag`,
    UPDATE_TAG: `${BASE_URL}/general/update-tag`,
    ADDORGANIZATION: `${BASE_URL}/users/create-organization`,
    GETORGANIZATIONS: `${BASE_URL}/users/organizations`,
    GETUSERPROFILE: `${BASE_URL}/users/individual-user`,

    // 🚀 TEMPLATE APIS
    TEMPLATES: `${BASE_URL}/templates`,
    CREATE_TEMPLATE: `${BASE_URL}/templates/create-template`,
    DELETE_TEMPLATE: `${BASE_URL}/templates/delete-template`,

    // 🚀 CHATBOT APIS
    CHATBOT: `${BASE_URL}/chatBot`,
    CHATBOT_CLICK_HISTORY: `${BASE_URL}/chatBot/clicked-history`,
    CREATE_CHAT_BOT: `${BASE_URL}/chatBot/chat-bot-creation`,
    EDIT_CAHT_BOT: `${BASE_URL}/chatBot/update-chat-bot`,
    DELETE_CHAT_BOT: `${BASE_URL}/chatBot/`,

    // 🚀 CAMPAIGNS APIS
    CAMPAIGNS: `${BASE_URL}/campaigns`,
    CAMPAIGNS_STATUS: `${BASE_URL}/campaigns/individual-campaign-status`,
    TAGWISE_USERS: `${BASE_URL}/campaigns/tag-wise-users`,
    CAMPAIGN_INPUTS: `${BASE_URL}/campaigns/template-input-parameters`,
    CREATE_CAMPAIGN: `${BASE_URL}/campaigns/create-campaigns`,
    CAMPAIGN_MESSAGES: `${BASE_URL}/campaigns/campaign-messages`,
    CAMPAIGN_RESEND_MESSAGES: `${BASE_URL}/campaigns/resend-messages`,

    // 🚀 FILE CATEGORY APIS
    CATEGORYS: `${BASE_URL}/files/categories`,
    CLIENTS: `${BASE_URL}/files/client`,
    USERS: `${BASE_URL}/files/user`,
    ADD_CATEGORY: `${BASE_URL}/files/add-categories`,
    ADD_CLIENT: `${BASE_URL}/files/add-client-files`,
    ADD_USER: `${BASE_URL}/files/add-user-files`,

    // 🚀 LEAD MANAGEMENT APIS
    LEVELS: `${BASE_URL}/lead/levels`,
    CALL_STATUS_TYPES: `${BASE_URL}/lead/call-status-types`,
    LEAD_STATUS_TYPES: `${BASE_URL}/lead/status-types`,
    LEAD_MANAGEMENT_LEADS: `${BASE_URL}/lead/`,
    MYTASK: `${BASE_URL}/lead/my-task`,
    LEAD_HISTORY: `${BASE_URL}/lead/history`,
    LEAD_HISTORY_UPDATE: `${BASE_URL}/lead/history-update`,
    UPDATE_UNASSIGN_LEADS: `${BASE_URL}/lead/unassigning-leads`,
    CREATENEW_UNASSIGN_LEADS: `${BASE_URL}/lead/assigning-leads`,
    LEVEL_HEAD_EMPLOYEES: `${BASE_URL}/lead/level-head-employees`,
    LEVEL_WISE_EMPLOYEES: `${BASE_URL}/lead/employees-by-head`,
    INDIVIDUAL_USER_TASK: `${BASE_URL}/lead/individual-user-tasks`,
    UN_ASSIGNED_EMPLOYEES: `${BASE_URL}/lead/un-assigned-employees`,
    ADD_LEVEL_EMPLOYEES: `${BASE_URL}/lead/add-level-employees`,
    DELETE_LEVEL_EMPLOYEES: `${BASE_URL}/lead/delete-level-employees`,

    //🚀 Whatsapp
    WA_MESSAGE_CONTACTS: `${BASE_URL}/messages/contacts`,
    WA_CHATS: `${BASE_URL}/messages/wa-chats`,
    SEND_MESSAGE: `${BASE_URL}/messages/send-message`,
    SEND_TEMPLATE: `${BASE_URL}/messages/send-template`,
    UPDARE_MESSAGE_COUNT: `${BASE_URL}/messages/update-seen-count`,
    CONTACT_FILTERS: `${BASE_URL}/messages/filters`,



    // ORGANIZATION FORMS
    ORG_FORMS: `${BASE_URL}/organization/forms`,
    ORG_FORM_FIELDS_TYPES: `${BASE_URL}/organization/form-field-types`,
    CREATE_ORG_FORM: `${BASE_URL}/organization/create-form`,
    ADD_FORM_RESPONSE: `${BASE_URL}/organization/add-form-response`,


    // QUOTATIONS
    QUOTATION_TEMPLATES: `${BASE_URL}/general/quotation-templates`,
    QUOTATION_LOGS: `${BASE_URL}/general/quotation-logs`,
    ADD_QUOTATION_LOG: `${BASE_URL}/general/add-quotation-log`,
};



